// ** JS MAIN FILE ** //

// Import modules
import { animations } from './modules/_animations.js';
animations();
// import { menu } from './modules/_menu.js';
// menu();

// Import templates
import { home } from './templates/_home.js';
home();
